class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.removeLine(this.dataset.index);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);
let sellingPlanWidgetsInitialized = false;
class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));

    // Initialize progress bar
    this.addToCartProgressBar();
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      if (event.source === 'product-form') {
        this.addToCartProgressBar();
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }
  addToCartProgressBar() {
    fetch('/cart.js') // Fetch the entire cart data as JSON
      .then((response) => response.json())
      .then((cartData) => {
        // Update the UI and progress bar with the entire cart data
        this.updateProgressBar(
          cartData.original_total_price,
          cartData.item_count,
          cartData.items.map((item) => item.sku),
        );
        sellingPlanWidgetsInitialized = false;
        initializeSellingPlanWidgets();
        sellingPlanWidgetsInitialized = true;
      })
      .catch((e) => {
        console.error('Error updating cart UI:', e);
      });
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    if (input) {
      input.value = input.getAttribute('value');
      this.isEnterPressed = false;
    }
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId,
      );
    }
  }

  onChange(event) {
    if (event.target.name === 'selling-plan') {
      console.log('onChange', event.target.dataset.line, event.target.dataset.quantity, event.target.value);
      this.updateSellingPlan(event.target.dataset.line, event.target.dataset.quantity, event.target.value);
      // this.addCartAttribute();
    } else if (event.target.name != '') {
      this.validateQuantity(event);
      // this.addCartAttribute();
    }
  }
  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  removeLine(line) {
    this.removeBundleByLine(Number(line)).catch((error) => {
      console.error('Error removing cart line:', error);
      this.updateQuantity(line, 0);
    });
  }

  async removeBundleByLine(line) {
    if (Number.isNaN(line)) {
      return;
    }

    const response = await fetch('/cart.js');
    const cart = await response.json();
    const foundItem = cart.items[line - 1];
    const bundleToRemove = foundItem?.properties?.bundle;

    if (!bundleToRemove) {
      this.updateQuantity(line, 0);
      return;
    }

    const updates = cart.items.reduce((linesToRemove, item) => {
      if (item.properties?.bundle === bundleToRemove) {
        linesToRemove[item.key] = 0;
      }

      return linesToRemove;
    }, {});

    if (!Object.keys(updates).length) {
      this.updateQuantity(line, 0);
      return;
    }

    this.updateQuantities(updates, line);
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector,
          );
        });

        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        sellingPlanWidgetsInitialized = false;
        initializeSellingPlanWidgets();
        sellingPlanWidgetsInitialized = true;
        // this.addCartAttribute();

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });

        const b2b = window.lgd.customer.b2b;
        const progressBarEnabled = window.lgd.features.progressBar.enabled;
        if (!b2b && progressBarEnabled) {
          const updatedCartTotal = parsedState.original_total_price;
          this.updateProgressBar(
            updatedCartTotal,
            parsedState.item_count,
            parsedState.items.map((item) => item.sku),
          );
        }
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateQuantities(updates, line, name, variantId) {
    this.enableLoading(line);
    const body = JSON.stringify({
      updates,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          if (quantityElement) {
            quantityElement.value = quantityElement.getAttribute('value');
          }
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector,
          );
        });

        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (
          quantityElement &&
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        sellingPlanWidgetsInitialized = false;
        initializeSellingPlanWidgets();
        sellingPlanWidgetsInitialized = true;

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && name && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });

        const b2b = window.lgd.customer.b2b;
        const progressBarEnabled = window.lgd.features.progressBar.enabled;
        if (!b2b && progressBarEnabled) {
          const updatedCartTotal = parsedState.original_total_price;
          this.updateProgressBar(
            updatedCartTotal,
            parsedState.item_count,
            parsedState.items.map((item) => item.sku),
          );
        }
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  /**
   * Add theme version to cart
   */
  addCartAttribute() {
    const themeVersion = {
      theme_version: 'v2',
    };
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ attributes: themeVersion }),
    });
  }

  updateProgressBar(currentValue, itemCount, skus = []) {
    itemCount = parseInt(itemCount);
    const progressBarContainers = document.querySelectorAll('.progress-bar-container');

    // Some SKUs always get free shipping, so the "Free Shipping" tier is unlocked regardless of the cart total
    const freeShippingSkus = (window.lgd.features.progressBar.freeShippingSkus || [])
      .map((sku) => sku.trim())
      .filter(Boolean);
    const hasFreeShippingSku = skus.some((sku) => sku && freeShippingSkus.includes(sku.trim().toUpperCase()));
    const isUnlocked = (marker) =>
      parseInt(marker.dataset.amount) <= currentValue ||
      (hasFreeShippingSku && marker.dataset.perk.trim().toLowerCase() === 'free shipping');

    progressBarContainers.forEach((progressBar) => {
      if (itemCount === 0) {
        progressBar.style.display = 'none';
      } else {
        progressBar.style.display = 'block';
      }

      const markers = progressBar.querySelectorAll('.marker');
      const maxAmount = markers[markers.length - 1].dataset.amount;

      const nextTier = Array.from(markers).find((marker) => !isUnlocked(marker));
      const leftAmount =
        window.lgd.features.progressBar.currencySymbol +
        ((nextTier ? parseInt(nextTier.dataset.amount) - currentValue : 0) / 100).toFixed(2);
      console.log('leftAmount', leftAmount);
      const percent = nextTier
        ? Math.min((currentValue / parseInt(markers[markers.length - 1].dataset.amount)) * 100, 100).toFixed(2)
        : 100;

      if (nextTier) {
        let reached = false;
        markers.forEach((marker) => {
          if (marker === nextTier) reached = true;
          if (!reached || isUnlocked(marker)) {
            marker.classList.add('ticked');
          } else {
            marker.classList.remove('ticked');
          }
        });
      } else {
        markers.forEach((marker) => marker.classList.add('ticked'));
      }

      /*let unlocked = [];
      markers.forEach(marker => unlocked.push(marker.dataset.perk));*/

      progressBar.querySelector('.progress-bar').style.setProperty('--percent', `${percent}%`);
      const isCartDrawerProgressBar = progressBar.closest('cart-drawer') || progressBar.closest('cart-drawer-items');
      progressBar.querySelector('.progress-bar-text').innerHTML = isCartDrawerProgressBar
        ? nextTier
          ? `Spend <strong>${leftAmount}</strong> more to get <strong>${nextTier.dataset.perk}</strong>`
          : markers.length === 1
            ? `Congrats! You unlocked <strong>${markers[0].dataset.perk}</strong>`
            : `Congrats! You've unlocked <strong>all perks</strong>`
        : nextTier
          ? `You are <strong>${leftAmount}</strong> away from getting <strong>${nextTier.dataset.perk}</strong>`
          : markers.length === 1
            ? `Congratulations! You unlocked ${markers[0].dataset.perk}`
            : `Congratulations! You've unlocked all perks`;

      //progressBar.querySelector('.complete').style.display = percent >= 100 ? 'block' : 'none';
    });
  }
  updateProgressBarOld(currentValue, itemCount) {
    const progressBarWrappers = document.querySelectorAll('.progress-bar-wrapper');
    const progressBars = document.querySelectorAll('.progress-bar');
    const progressLabels = document.querySelectorAll('.progress-label');

    const markerFreeShipping = document.getElementById('marker-free-shipping');
    const markerFreeGift = document.getElementById('marker-free-gift');
    const tierAchievementMessage = document.getElementById('tier-achievement-message');

    if (!markerFreeShipping || !markerFreeGift || !tierAchievementMessage) {
      console.error('Markers or message not found in the DOM');
      return;
    }
    const progressBarVariables = window.lgd.features.progressBar;
    progressBars.forEach((progressBar, index) => {
      const progressLabel = progressLabels[index];
      const progressBarWrapper = progressBarWrappers[index];

      // Progress Bar Data
      const {
        freeShippingEnabled,
        freeGiftEnabled,
        freeProductId: freeGiftProduct,
        freeProductPrice,
        freeShippingTier: rawFreeShippingTier,
        freeGiftTier: rawFreeGiftTier,
        currencySymbol,
        messages: {
          freeShipping: freeShippingMessage,
          freeGift: freeGiftMessage,
          freeShippingEnd: freeShippingMessageEnd,
        },
      } = progressBarVariables;

      const freeShippingTier = Number(rawFreeShippingTier) || 0;
      const freeGiftTier = Number(rawFreeGiftTier) || 0;

      if (!progressBarWrapper || !progressBar || !progressLabel) {
        console.error('Progress bar elements not found in the DOM');
        return;
      }
      if (itemCount == 0) {
        progressBarWrapper.style.display = 'none';
      } else {
        progressBarWrapper.style.display = 'block';
      }

      let message = '';
      let progressPercentage = 0;
      let tierAchieved = false;
      let achievementText = '';

      if (freeGiftEnabled && freeShippingEnabled) {
        if (currentValue >= freeGiftTier && currentValue >= freeShippingTier) {
          message = progressBarVariables.messages.progressBarAchieved;
          tierAchievementMessage.style.display = 'none';
          const freeGiftMessage = document.getElementById('free_gift_message');
          freeGiftMessage.classList.remove('hidden');
        } else if (currentValue >= freeShippingTier) {
          message = freeShippingMessage;
          tierAchieved = true;
          achievementText = progressBarVariables.messages.achievement.freeShipping;
          if (currentValue < freeGiftTier) {
            message = `Add ${currencySymbol}${((freeGiftTier - currentValue) / 100).toFixed(2)} more for free gift.`;
          }
        } else if (currentValue >= freeGiftTier) {
          message = freeGiftMessage;
          tierAchieved = true;
          achievementText = progressBarVariables.messages.achievement.freeGift;
          if (currentValue < freeShippingTier) {
            message = `Add ${currencySymbol}${((freeShippingTier - currentValue) / 100).toFixed(
              2,
            )} more for free shipping.`;
          }
        } else {
          const nextTier = Math.min(freeGiftTier, freeShippingTier);
          const nextReward = nextTier === freeGiftTier ? 'free gift' : 'free shipping';
          message = `Add ${currencySymbol}${((nextTier - currentValue) / 100).toFixed(
            2,
          )} more for Free Shipping & Gift.`;
        }
      } else if (freeGiftEnabled) {
        if (currentValue >= freeGiftTier) {
          message = freeGiftMessage;
          tierAchieved = true;
          achievementText = progressBarVariables.messages.achievement.freeGift;
        } else {
          message = `Add ${currencySymbol}${((freeGiftTier - currentValue) / 100).toFixed(2)} more for free gift.`;
        }
      } else if (freeShippingEnabled) {
        if (currentValue >= freeShippingTier) {
          message = freeShippingMessage;
          tierAchieved = true;
          achievementText = progressBarVariables.messages.achievement.freeShipping;
        } else {
          message = `Add ${currencySymbol}${((freeShippingTier - currentValue) / 100).toFixed(
            2,
          )} ${freeShippingMessageEnd}`;
        }
      }

      if (freeGiftEnabled && freeShippingEnabled) {
        progressPercentage = Math.min((currentValue / Math.max(freeGiftTier, freeShippingTier)) * 100, 100);
      } else if (freeGiftEnabled) {
        progressPercentage = Math.min((currentValue / freeGiftTier) * 100, 100);
      } else if (freeShippingEnabled) {
        progressPercentage = Math.min((currentValue / freeShippingTier) * 100, 100);
      }
      progressBar.style.width = progressPercentage + '%';
      progressLabel.textContent = message;

      if (freeShippingEnabled && currentValue >= freeShippingTier) {
        markerFreeShipping.classList.add('ticked');
        markerFreeShipping.textContent = '✓';
      } else {
        markerFreeShipping.classList.remove('ticked');
        markerFreeShipping.textContent = `${currencySymbol}${Math.round(freeShippingTier / 100)}`;
      }

      if (freeShippingEnabled) {
        markerFreeShipping.style.left = `${Math.min(
          (freeShippingTier / Math.max(freeGiftTier, freeShippingTier)) * 100,
          95,
        )}%`;
        markerFreeShipping.style.display = 'flex';
      } else {
        markerFreeShipping.style.display = 'none';
      }

      if (freeGiftEnabled && currentValue >= freeGiftTier) {
        markerFreeGift.classList.add('ticked');
        markerFreeGift.textContent = '✓';
        this.handleFreeGift(freeGiftProduct, freeGiftTier);
      } else {
        markerFreeGift.textContent = `${currencySymbol}${Math.round(freeGiftTier / 100)}`;
        markerFreeGift.classList.remove('ticked');
        if (freeGiftEnabled) {
          this.handleFreeGift(freeGiftProduct, freeGiftTier);
        }
      }

      if (!freeGiftEnabled && freeShippingEnabled) {
        markerFreeShipping.style.left = '95%';
        markerFreeShipping.style.display = 'flex';
        markerFreeGift.style.display = 'none';
      }

      if (tierAchieved && !(currentValue >= freeGiftTier && currentValue >= freeShippingTier)) {
        if (freeGiftEnabled && freeShippingEnabled) {
          tierAchievementMessage.classList.remove('hidden');
          tierAchievementMessage.textContent = achievementText;
        }
      } else {
        tierAchievementMessage.classList.add('hidden');
      }
    });
  }

  handleFreeGift(productId, freeGiftTier) {
    // Check if the free product is already in the cart
    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        const useProgressBarFreeGiftTier = window.lgd.features.checkoutButtonFreeGift.useFreeGiftTier;
        let freeProductItem;
        if (useProgressBarFreeGiftTier) {
          freeProductItem = cart.items.find((item) => {
            return item.id === Number(productId) && item.properties && item.properties['_freeProduct'];
          });
        } else {
          const checkoutButtonFreeGiftTier = window.lgd.features.checkoutButtonFreeGift.freeGiftProductId;
          freeProductItem = cart.items.find((item) => {
            return item.id === Number(checkoutButtonFreeGiftTier) && item.properties && item.properties['_freeProduct'];
          });
        }
        const packageProtectionItem = cart.items.find((item) => {
          return item.title.includes('Package Protection');
        });

        if (freeProductItem && cart.items.length === 1) {
          const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
          const itemKey = cartItems.querySelector(`[data-variant-id="${freeProductItem.id}"]`)?.dataset.index;
          this.updateQuantity(itemKey, 0);
        } else {
          // Subtract the cost of the free product if it's in the cart
          const adjustedCurrentValue = freeProductItem
            ? cart.total_price -
              freeProductItem.final_line_price -
              (packageProtectionItem ? packageProtectionItem.final_line_price : 0)
            : cart.total_price - (packageProtectionItem ? packageProtectionItem.final_line_price : 0);
          const checkoutButton = document.querySelector('checkout-button');
          checkoutButton.setAttribute('data-total-price', adjustedCurrentValue);
          if (adjustedCurrentValue < freeGiftTier && freeProductItem) {
            // Remove the free product if the threshold is not met
            const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
            const itemKey = cartItems.querySelector(`[data-variant-id="${freeProductItem.id}"]`)?.dataset.index;
            this.updateQuantity(itemKey, 0);
          }
        }
      })
      .catch((error) => {
        console.error('Error checking cart contents:', error);
      });
  }

  updateSellingPlan(line, quantity, sellingPlanId, variantId) {
    this.enableLoading(line);
    // Add theme version to cart
    // this.addCartAttribute();
    const body = JSON.stringify({
      line: line,
      quantity: quantity,
      selling_plan: sellingPlanId,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        console.log(parsedState);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        const toggleSelect = document.getElementById(`toggle-select-${line}`);
        if (toggleSelect) {
          toggleSelect.checked = sellingPlanId;
        }

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector,
          );
        });
        const message = '';
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });

        const b2b = window.lgd.customer.b2b;
        const progressBarEnabled = window.lgd.features.progressBar.enabled;
        if (!b2b && progressBarEnabled) {
          const updatedCartTotal = parsedState.original_total_price;
          this.updateProgressBar(
            updatedCartTotal,
            parsedState.item_count,
            parsedState.items.map((item) => item.sku),
          );
        }
        sellingPlanWidgetsInitialized = false;
        initializeSellingPlanWidgets();
        sellingPlanWidgetsInitialized = true;
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        console.log('errors', errors);
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);

    let errorMessage = '';
    if (message == 'You can only add 1 of this item to your cart.') {
      errorMessage = 'Please Try Again';
    } else {
      errorMessage = message;
    }
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = errorMessage;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER),
        );
      }
    },
  );
}

function initializeSellingPlanWidgets() {
  console.log('initializeSellingPlanWidgets');
  if (sellingPlanWidgetsInitialized) {
    return; // Exit if already initialized
  }
  const checkboxes = document.querySelectorAll('.selling-plan-checkbox');
  const selects = document.querySelectorAll('.selling-plan-select');
  const subscriptionIconWrappers = document.querySelectorAll('.cart-item__subscription-icon-wrapper');

  const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');

  checkboxes.forEach((checkbox, index) => {
    const select = selects[index];

    // Set checkbox state based on select index
    //checkbox.checked = select.selectedIndex !== 0;

    // if (subscriptionIconWrappers[index]) {
    //   // Initial visibility based on checkbox state
    //   subscriptionIconWrappers[index].style.display = checkbox.checked ? 'flex' : 'none';
    // }

    // Add event listener to toggle visibility and reset select index
    checkbox.addEventListener('change', () => {
      if (!checkbox.checked) {
        select.selectedIndex = 0; // Reset select to index 0
        cartItems.updateSellingPlan(select.dataset.line, select.dataset.quantity, '', select.dataset.variantId);
      } else {
        select.selectedIndex = 1; // Set select to index 1 when checkbox is checked
        cartItems.updateSellingPlan(
          select.dataset.line,
          select.dataset.quantity,
          select.value,
          select.dataset.variantId,
        );
      }
      // if (subscriptionIconWrappers[index]) {
      //   subscriptionIconWrappers[index].style.display = checkbox.checked ? 'flex' : 'none';
      // }
    });
    // Add event listener to update checkbox based on select change
    select.addEventListener('change', () => {
      //checkbox.checked = select.selectedIndex !== 0;
      // if (checkbox.checked) {
      cartItems.updateSellingPlan(select.dataset.line, select.dataset.quantity, select.value, select.dataset.variantId);
      // }
    });
  });
  sellingPlanWidgetsInitialized = true;
}

document.addEventListener('DOMContentLoaded', () => {
  initializeSellingPlanWidgets();
});

customElements.define(
  'checkout-button',
  class extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', async (event) => {
        event.target.disabled = true;
        event.preventDefault();
        event.stopPropagation();

        const progressBarFreeGiftTier = window.lgd.features.progressBar.freeGiftTier;
        const useProgressBarFreeGiftTier = window.lgd.features.checkoutButtonFreeGift.useFreeGiftTier;
        const checkoutButtonFreeGiftTier = window.lgd.features.checkoutButtonFreeGift.freeGiftTier;

        let productId;
        const totalPrice = this.getAttribute('data-total-price');
        let TotalBelowThreshold = false;

        // Check if the total price is below the threshold for the progress bar free gift tier
        if (useProgressBarFreeGiftTier) {
          productId = window.lgd.features.progressBar.freeProductId;
          if (totalPrice < progressBarFreeGiftTier) {
            TotalBelowThreshold = true;
          }
        } else {
          // Check if the total price is below the threshold for the checkout button free gift tier
          productId = window.lgd.features.checkoutButtonFreeGift.freeGiftProductId;

          if (totalPrice < checkoutButtonFreeGiftTier) {
            TotalBelowThreshold = true;
          }
        }

        const isProductInCart = document.querySelector(`[data-variant-id="${productId}"]`) !== null;

        if (!isProductInCart && !TotalBelowThreshold) {
          console.log('Adding free product to cart');
          event.target.textContent = 'Adding free product...';
          await addFreeProductToCart(productId);
          event.target.textContent = 'Going to checkout...';
        } else if (isProductInCart && TotalBelowThreshold) {
          event.target.textContent = 'Below threshold. Removing free product...';
          const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
          const itemKey = cartItems.querySelector(`[data-variant-id="${productId}"]`)?.dataset.index;
          console.log('itemKey', itemKey);
          cartItems.updateQuantity(itemKey, 0);
          event.target.textContent = 'Going to checkout...';
          window.location.href = '/checkout';
        } else {
          window.location.href = '/checkout';
        }
      });
    }
  },
);

function addFreeProductToCart(freeGiftProduct) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      items: [
        {
          id: freeGiftProduct,
          quantity: 1,
          properties: { _freeProduct: true },
        },
      ],
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      window.location.href = '/checkout';
    })
    .catch((error) => {
      console.error('Error adding free gift:', error);
    });
}
